import { useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";

const inputCls = "mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0E2240]";
const dt = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Kolkata" }) : "—");

export default function RescheduleDialog({ booking, onClose, onDone }) {
  const [slot, setSlot] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!slot) { toast.error("Pick the new date & time"); return; }
    setBusy(true);
    try {
      await api.patch(`/bookings/${booking.id}/slot`, { slot_start: new Date(slot).toISOString(), note: note.trim() || null });
      toast.success("Slot changed — SM and TDC alerted"); onDone(); onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-black/60 p-0 sm:p-4" onClick={onClose}>
      <div data-testid="reschedule-dialog" className="w-full max-w-sm rounded-t-2xl sm:rounded-2xl bg-white p-5" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-heading text-lg font-bold text-[#0E2240]">Reschedule {booking.reg_no}</h3>
        <p className="mt-1 text-xs text-slate-500">{booking.kec_name} → {booking.customer_name} · current slot {dt(booking.slot_start)}</p>
        <label className="mt-3 block text-[10px] font-semibold uppercase tracking-wider text-slate-500">New date & time</label>
        <input data-testid="reschedule-slot-input" type="datetime-local" value={slot} onChange={(e) => setSlot(e.target.value)}
          min={new Date(Date.now() + 10 * 60000).toISOString().slice(0, 16)} max={new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 16)} className={inputCls} />
        <input data-testid="reschedule-note-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Reason (optional)" className={inputCls} />
        <div className="mt-4 grid grid-cols-2 gap-2">
          <button onClick={onClose} className="rounded-xl border border-slate-200 py-2.5 text-xs font-bold text-slate-500">Cancel</button>
          <button data-testid="reschedule-save-btn" disabled={busy} onClick={save} className="rounded-xl bg-[#0E2240] py-2.5 text-xs font-bold text-white disabled:opacity-60">{busy ? "Saving…" : "Change slot"}</button>
        </div>
      </div>
    </div>
  );
}
